export const BRAND = {
  name: "EarlyPrint",
  legalName: "EarlyPrint",
  tagline: "Print anything. From anywhere.",
  phone: "9899747172",
  phoneIntl: "+91 98997 47172",
  email: "hello@earlyprint.in",
  location: "Delhi NCR, India",
  address: "Delhi NCR, India",
  logo: "https://customer-assets.emergentagent.com/job_0c0426a9-ad29-45c1-b008-5bc50e0bdca2/artifacts/6edco6iq_earlyprint_logo_circle_v2.webp",
  upi: {
    id: "9899747172@ybl",
    qr: "https://customer-assets.emergentagent.com/job_website-earlyprint/artifacts/n6nspoh9_WhatsApp%20Image%202026-07-14%20at%2014.06.47.jpeg",
  },
  social: {
    whatsapp: "https://wa.me/919899747172?text=Hi%2C%20I%20want%20to%20place%20a%20print%20order%20on%20EarlyPrint",
    whatsappRaw: "https://wa.me/919899747172",
    instagram: "https://www.instagram.com/officialearlyprint",
    facebook: "https://www.facebook.com/share/1KjP1MvdfT/",
    linkedin: "https://www.linkedin.com/company/earlyprint",
    youtube: "https://www.youtube.com/@earlyprint",
    twitter: "https://x.com/earlyprint",
  },
};

export const CATEGORIES = [
  { key: "business", label: "Business Stationery", desc: "Visiting cards, letterheads, envelopes", price: "₹149", img: "https://images.unsplash.com/photo-1623305463957-df17547327cb?crop=entropy&cs=srgb&fm=jpg&q=85&w=600" },
  { key: "marketing", label: "Marketing & Promotional", desc: "Flyers, brochures, pamphlets", price: "₹299", img: "https://images.pexels.com/photos/6620992/pexels-photo-6620992.jpeg?auto=compress&w=600" },
  { key: "packaging", label: "Packaging", desc: "Custom boxes, labels, tapes", price: "₹499", img: "https://images.unsplash.com/photo-1566576721346-d4a3b4eaeb55?crop=entropy&cs=srgb&fm=jpg&q=85&w=600" },
  { key: "books", label: "Books & Publications", desc: "Perfect bound, spiral, hard case", price: "₹399", img: "https://images.unsplash.com/photo-1519681393784-d120267933ba?crop=entropy&cs=srgb&fm=jpg&q=85&w=600" },
  { key: "apparel", label: "Apparel & Merchandise", desc: "T-shirts, hoodies, mugs, caps", price: "₹249", img: "https://images.unsplash.com/photo-1620799139507-2a76f79a2f4d?crop=entropy&cs=srgb&fm=jpg&q=85&w=600" },
  { key: "signage", label: "Signage & Large Format", desc: "Flex banners, LED boards, standees", price: "₹599", img: "https://images.unsplash.com/photo-1558618666-fcd25c85cd64?crop=entropy&cs=srgb&fm=jpg&q=85&w=600" },
  { key: "photo", label: "Photo & Fine Art", desc: "Canvas, framed prints, posters", price: "₹349", img: "https://images.unsplash.com/photo-1513519245088-0e12902e5a38?crop=entropy&cs=srgb&fm=jpg&q=85&w=600" },
  { key: "wedding", label: "Wedding & Event", desc: "Cards, envelopes, favors", price: "₹19/card", img: "https://images.unsplash.com/photo-1519741497674-611481863552?crop=entropy&cs=srgb&fm=jpg&q=85&w=600" },
  { key: "security", label: "Security & Specialty", desc: "Certificates, tickets, holograms", price: "₹499", img: "https://images.unsplash.com/photo-1554224155-6726b3ff858f?crop=entropy&cs=srgb&fm=jpg&q=85&w=600" },
  { key: "industrial", label: "Industrial / Pharma / Food", desc: "Compliance labels, inserts", price: "₹899", img: "https://images.unsplash.com/photo-1587293852726-70cdb56c2866?crop=entropy&cs=srgb&fm=jpg&q=85&w=600" },
  { key: "stickers", label: "Stickers & Labels", desc: "Vinyl, transparent, kiss-cut", price: "₹199", img: "https://images.unsplash.com/photo-1626785774573-4b799315345d?crop=entropy&cs=srgb&fm=jpg&q=85&w=600" },
];

export const HERO_BANNERS = [
  {
    id: 1,
    eyebrow: "India's printing marketplace",
    title: "Print anything.",
    titleAccent: "From anywhere.",
    body: "Upload a file, get live quotes from verified vendors nearby, and track delivery like a food order — all on one screen.",
    cta: { label: "Get a Quote", to: "/signup" },
    secondaryCta: { label: "How it works", to: "#how" },
    bg: "https://images.unsplash.com/photo-1758183961426-88d64eb5f787?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
  },
  {
    id: 2,
    eyebrow: "Real-time",
    title: "Live bidding —",
    titleAccent: "vendors compete for your order.",
    body: "Countdown, transparent quotes, side-by-side comparison. You pick who prints — nobody guesses over the phone.",
    cta: { label: "Try live bidding", to: "/signup" },
    secondaryCta: { label: "See categories", to: "#what-we-print" },
    bg: "https://images.pexels.com/photos/6620992/pexels-photo-6620992.jpeg?auto=compress&w=1600",
  },
  {
    id: 3,
    eyebrow: "For print shops",
    title: "Pre-paid orders.",
    titleAccent: "Zero lead fees.",
    body: "Join EarlyPrint free. Get verified in 24 hours. Every order is held in escrow — you get paid on time, every time.",
    cta: { label: "Register your shop", to: "/vendor/register" },
    secondaryCta: { label: "Why EarlyPrint", to: "/about" },
    bg: "https://images.unsplash.com/photo-1562240020-ce31ccb0fa7d?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
  },
];
